import { render, staticRenderFns } from "./OfferCreate.vue?vue&type=template&id=319423b7&scoped=true&"
import script from "./OfferCreate.vue?vue&type=script&lang=js&"
export * from "./OfferCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfferCreate.vue?vue&type=style&index=0&id=319423b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319423b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VFileInput,VSelect,VTextField})
